export default async () => {
      // planning

  // remove ssr planning
  const ssrPlanning = document.querySelector("#ssr-planning")
  if (ssrPlanning) ssrPlanning.remove()
  await window.appInitializer.initPlanningApp()


  // function initPlanning(){
  //   const planningRoot = document.querySelector('#planner-app');
  //   if (planningRoot && elementInViewport(planningRoot)) {
  //     window.appInitializer.initPlanningApp()
  //       window.removeEventListener('scroll', initPlanning)
  //     }
  // }

  // window.addEventListener('scroll', initPlanning)

}